<template>
  <header class="daynav" style="background: transparent !important; box-shadow: unset !important">
    <div class="container-fluid">
      <div class="nav-scroller">
        <nav class="nav-scroller-nav w-100">
          <ul
            class="nav-pills nav-scroller-content"
            id="pills-tab"
            role="tablist"
            data-cy="day-btn-group"
          >
            <li
              class="nav-item"
              role="presentation"
              v-for="(day, i) in days"
              :key="day.conference_days_id"
            >
              <button
                class="btn"
                :id="`day${i + 1}-button`"
                data-bs-toggle="pill"
                :data-bs-target="`#day${i + 1}-content`"
                type="button"
                role="tab"
                :aria-controls="`day${i + 1}-button`"
                aria-selected="true"
                :class="{
                  active: day.conference_days_id == activeDay
                }"
                @click="
                  {
                    $event.stopPropagation();
                    if (scroller) {
                      getEl(`agenda-day-${day.conference_days_id}`)?.scrollIntoView({
                        behavior: 'auto'
                      });
                    } else $emit('update:activeDay', day.conference_days_id);
                  }
                "
                :data-cy="`day-btn-${day.conference_days_id}`"
              >
                <!-- <small>{{ dayjs(day.start).format("ddd") }}</small> -->
                <small>{{ dayjs.utc(day.start).format("MMM") }}</small>
                <span
                  data-cy="day-btn-day-of-month"
                  :data-cy-date="dayjs.utc(day.start).format('YYYY-MM-DD')"
                  >{{ dayjs.utc(day.start).format("D") }}</span
                >
                <small
                  >{{ dayjs.utc(day.start).format("h:mm A") }} -
                  {{ dayjs.utc(day.end).format("h:mm A") }}</small
                >
              </button>
            </li>
          </ul>
        </nav>

        <button
          class="nav-scroller-btn nav-scroller-btn--left"
          @change="navChange()"
          aria-label="Scroll left"
        >
          <i class="bi bi-chevron-left"></i>
        </button>

        <button
          class="nav-scroller-btn nav-scroller-btn--right"
          @change="navChange()"
          aria-label="Scroll right"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </header>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";
import dayjs from "dayjs";

import PriorityNavScroller from "priority-nav-scroller";
import type { ConferenceDay } from "@/api_types/teacher";
onMounted(() => {
  // Init multiple nav scrollers with the same options
  let navScrollers = document.querySelectorAll(".nav-scroller");

  navScrollers.forEach((currentValue) => {
    PriorityNavScroller({
      selector: currentValue
    });
  });
});

defineProps<{
  days: ConferenceDay[];
  activeDay: string;
  scroller?: boolean;
}>();

defineEmits<{
  (event: "update:activeDay", val: string): void;
}>();

function navChange() {
  // let navScrollersActive = document.querySelectorAll(".nav-scroller-btn.active");
}

const getEl = (id: string) => document.getElementById(id);
</script>

<style lang="scss" scoped>
header.daynav,
.container-fluid {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: unset !important;
}
</style>
